import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import {makeInitialDataItems} from "../helpers/initial-info-items.jsx";
import ObservationBox from "../../../../../../components/observation-box/observation-box.jsx";

export default function InitialInfo({ data, printOptions }) {
    const initialData = makeInitialDataItems(data, printOptions);
    const transcription = data?.attendance?.data?.attendance_transcription ?? "";

    return (
        <>
            <InfoGrid title="DADOS INICIAIS" items={initialData}  />
            <div className="px-5 mt-8">
                <ObservationBox title="Transcrição">
                    {transcription}
                </ObservationBox>
            </div>
        </>
    )
}